<template>
  <div class="layout--page" ref="layout">
    <header-block ref="header" />
    <main ref="main" class="page">
      <div class="page__container">
        <slot />
      </div>
    </main>
    <footer-block ref="footer" />
  </div>
</template>

<script>
import HeaderBlock from '@/layouts/Header';
import FooterBlock from '@/layouts/Footer';

export default {
  name: 'Page',

  components: {
    HeaderBlock,
    FooterBlock,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    loading(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$root.$emit('page-loading', newValue);
      }
    },
  },

  created() {
    this.resizeThrottlerFunctionList = [
      ...this.resizeThrottlerFunctionList,
      this.setMainOffset,
      // this.setMainMaxHeight,
    ];
  },

  mounted() {
    this.setMainOffset();
    // this.setMainMaxHeight()
  },

  methods: {
    setMainOffset() {
      const $main = this.$refs.main;
      const height = this.$refs.header.$el.offsetHeight;

      $main.style.marginTop = `${height}px`;
    },

    setMainMaxHeight() {
      const $main = this.$refs.main;
      const headerHeight = this.$refs.header.$el.offsetHeight;
      const footerHeight = this.$refs.footer.$el.offsetHeight;

      $main.style.maxHeight = `calc(100vh - (${headerHeight + footerHeight}px))`;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "../sass/variables"
@import "../sass/mixins"

.page
  +Size(100%)

  display: flex
  max-width: $sMWContainer
  flex-grow: 1
.page__container
  +PageLayoutContainer(false)
  flex-grow: 1
</style>
